<template>

  <section class="news-section">

    <template v-if="news.length">

      <div class="news-grid">

        <RouterLink
            v-for="item in news"
            :key="item.id"
            :to="`/news/${item.slug}`"
            class="news-card"
        >

          <div class="news-image">

            <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                :alt="item.title"
                loading="lazy"
            >

            <div
                v-else
                class="no-image"
            >⚽</div>

          </div>

          <div class="news-body">

            <h4 class="news-title">{{ item.title }}</h4>

            <p
                v-if="item.summary"
                class="news-summary"
            >{{ item.summary }}</p>

            <div class="news-meta">

              <span
                  v-if="item.source"
                  class="source"
              >

                <img
                    v-if="item.source.logo"
                    :src="item.source.logo"
                    :alt="item.source.name"
                >

                {{ item.source.name }}

              </span>

              <span class="date">{{ formatDate(item.publishedAt) }}</span>

            </div>

          </div>

        </RouterLink>

      </div>

    </template>

    <div
        v-else
        class="empty-state"
    >

      📰 خبری برای این لیگ ثبت نشده

    </div>

  </section>

</template>

<script>

export default {

  name: 'CompetitionNews',

  props: {

    news: {

      type: Array,

      default: () => []

    }

  },

  methods: {

    formatDate(dateStr) {

      if (!dateStr) return '';

      try {

        const date = new Date(dateStr);

        return new Intl.DateTimeFormat(
            'fa-IR-u-ca-persian',
            { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Tehran' }
        ).format(date);

      } catch (e) {

        return '';

      }

    }

  }

}

</script>

<style scoped>

.news-grid{

  display:grid;

  grid-template-columns:repeat(auto-fill, minmax(270px, 1fr));

  gap:16px;

}

.news-card{

  background:#fff;

  border-radius:18px;

  overflow:hidden;

  box-shadow:0 4px 12px rgba(0,0,0,.06);

  text-decoration:none;

  color:inherit;

  display:flex;

  flex-direction:column;

  transition:.25s;

}

.news-card:hover{

  box-shadow:0 10px 24px rgba(0,0,0,.12);

  transform:translateY(-3px);

}

.news-image{

  height:160px;

  background:#f1f5f9;

}

.news-image img{

  width:100%;

  height:100%;

  object-fit:cover;

}

.no-image{

  height:100%;

  display:flex;

  align-items:center;

  justify-content:center;

  font-size:40px;

}

.news-body{

  padding:14px 16px 16px;

  display:flex;

  flex-direction:column;

  gap:8px;

  flex:1;

}

.news-title{

  font-size:14px;

  font-weight:700;

  line-height:1.7;

  color:#0f172a;

  margin:0;

  display:-webkit-box;

  -webkit-line-clamp:2;

  -webkit-box-orient:vertical;

  overflow:hidden;

}

.news-summary{

  font-size:12.5px;

  color:#64748b;

  line-height:1.8;

  margin:0;

  display:-webkit-box;

  -webkit-line-clamp:2;

  -webkit-box-orient:vertical;

  overflow:hidden;

}

.news-meta{

  margin-top:auto;

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:8px;

  font-size:11.5px;

  color:#94a3b8;

}

.source{

  display:flex;

  align-items:center;

  gap:6px;

  font-weight:600;

  color:#475569;

}

.source img{

  width:18px;

  height:18px;

  border-radius:50%;

  object-fit:contain;

}

.empty-state{

  background:#fff;

  border-radius:18px;

  padding:70px 24px;

  text-align:center;

  color:#64748b;

}

@media(max-width:600px){

  .news-grid{

    grid-template-columns:1fr;

  }

}

</style>